import baseMixin from '../mixin'

export default {
    mixins:[baseMixin],
    data(){
        return {
            formData: {
                srcLabel: 2
            },
            Tools: {
                show: true,
                data: [
                    {
                        name: "添加",
                        operate: "add",
                        theme: "primary"
                    },
                    {
                        name: "批量导入",
                        operate: "upload",
                        theme: "info"
                    },
                    {
                        name: "批量提交",
                        operate: "batchSubmit",
                        more: true,
                        batch: true
                    },
                    {
                        name: "批量确认",
                        operate: "confirm",
                        more: true,
                        batch:true
                    },
                    {
                        name: "批量取消",
                        operate: "batchcancel",
                        more: true,
                        batch:true
                    },
                    {
                        name: "批量导出",
                        val: "download",
                        more: true,
                        batch:true,
                    },
                ]
            },
        }
    },
    computed: {
        orderStatus(){
            return [
                {
                    value: 0,
                    label: '草稿',
                    theme:'info',
                },
                {
                    value: 3,
                    label: '已驳回',
                    theme:'error',
                }, 
                {
                    value: 5,
                    label: '待审核',
                    theme:'warning'
                },
                {
                    label: "审核中",
                    value: 6,
                    theme: 'warning'
                },
                {
                    label: "待确认",
                    value: 8,
                    theme: 'success'
                },
                {
                    value: 10,
                    label: '待出库',
                    theme:'primary'
                },
                {
                    value: 15,
                    label: '出库中',
                    theme:'warning',
                },
                {
                    value: 20,
                    label: '已出库',
                    theme:'primary'
                },
                {
                    value: 25,
                    label: '入库中',
                    theme: 'warning',
                },
                {
                    value: 70,
                    label: '已完成',
                    theme:'success',
                },
               /*  {
                    value: 90,
                    label: '已关闭',
                    theme:'error',
                }, */
               /*  {
                    value: 110,
                    label: '已关闭',
                    theme:'error',
                } */
                {
                    label: "已取消",
                    value: 110,
                    theme: 'error'
                },
                {
                    label: "取消异常",
                    value: 120,
                    theme: 'error'
                }
            ];
        }
    },
}